import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { authRoles } from 'app/auth';
import RxManagementLayout from './layouts/RxManagementLayout';

const RxManagementPage = lazy(() => import('./RxManagementPage'));

const RxManagementConfig = {
  settings: {
    layout: {
      config: {
        footer: { display: false },
        healtheraHeader: { display: false },
      },
    },
  },
  auth: authRoles.support,
  routes: [
    {
      path: 'rx-management',
      element: <RxManagementLayout />,
      children: [
        { path: '', element: <Navigate to="requested" replace /> },
        { path: 'requested', element: <RxManagementPage /> },
      ],
    },
  ],
};

export default RxManagementConfig;
